import React, { useEffect, useState, useCallback, useRef } from "react";
import { Container, RndContent, CertificateMenu } from "./styles";

import { Rnd } from "react-rnd";
import { pxToCm, cmToPx } from "../../../../utils/Utils";

const CertificateEditor = (props) => {
  const [certificadoLoc, setCertificadoLoc] = useState({
    nome_loc: {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      icon: <i className="user icon"></i>,
      text: "Nome do aluno",
      display: props.display,
    },
    qrcode_loc: {
      x: 0,
      y: 0,
      w: 20,
      h: 2,
      icon: <i className="qrcode icon"></i>,
      text: "QR Code",
      display: props.display,
    },
    iconcurso_loc: {
      x: 0,
      y: 0,
      w: 20,
      h: 2,
      icon: <i className="clone icon"></i>,
      text: "Ícone do curso",
      display: props.display,
    },
    assinaturavoitto_loc: {
      x: 0,
      y: 0,
      w: 20,
      h: 2,
      icon: <i className="pencil icon"></i>,
      text: "Assinatura da Voitto",
      display: props.display,
    },
    assinaturaconsultor_loc: {
      x: 0,
      y: 0,
      w: 20,
      h: 2,
      icon: <i className="pencil icon"></i>,
      text: "Assinatura do consultor",
      display: props.display,
    },
    descricao_loc: {
      x: 0,
      y: 0,
      w: 20,
      h: 2,
      icon: <i className="align center icon"></i>,
      text: "Descrição do Certificado",
      display: props.display,
    },
    fundo_loc: {
      x: 0,
      y: 0,
      w: 29.57,
      h: 20.86,
      html: (
        <>
          <i className="user icon"></i> Nome do aluno
        </>
      ),
      display: props.display,
    },
  });
  const [backgroundImageUrl, setBackgroundImageUrl] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");

  useEffect(() => {
    const newCertificadoLoc = { ...certificadoLoc };
    Object.keys(newCertificadoLoc).map((key) => {
      newCertificadoLoc[key].x = Number(props.certificado[key].split(",")[0]);
      newCertificadoLoc[key].y = Number(props.certificado[key].split(",")[1]);
      newCertificadoLoc[key].w = Number(props.certificado[key].split(",")[2]);
      newCertificadoLoc[key].h = Number(props.certificado[key].split(",")[3]);
    });
    setCertificadoLoc(newCertificadoLoc);
  }, []);

  useEffect(() => {
    handleBackgroundUrl();
  }, [props.certificado.fundo]);

  const handleBackgroundUrl = useCallback(() => {
    if (!backgroundImageUrl) {
      setBackgroundImageUrl(props.certificado.fundo);
    }
  }, [props.certificado.fundo, backgroundImageUrl]);

  useEffect(() => {
    handleCertificado();
  }, [certificadoLoc, backgroundImage]);

  const handleCertificado = useCallback(() => {
    const newCertificado = { ...props.certificado };

    Object.keys(certificadoLoc).map((key) => {
      newCertificado[key] = `${certificadoLoc[key].x.toFixed(
        2
      )},${certificadoLoc[key].y.toFixed(2)},${certificadoLoc[key].w.toFixed(
        2
      )},${certificadoLoc[key].h.toFixed(2)}`;
    });

    if (!newCertificado.fundo || backgroundImage) {
      newCertificado.fundo = backgroundImage;
    }

    props.setCertificado(newCertificado);
  }, [props.certificado, certificadoLoc, backgroundImage]);

  const showField = useCallback(
    (key) => {
      const newCertificadoLoc = { ...certificadoLoc };
      newCertificadoLoc[key].display = true;

      setCertificadoLoc(newCertificadoLoc);
    },
    [certificadoLoc]
  );

  const deleteField = useCallback(
    (event, key) => {
      //double-click
      if (event.detail === 2 && certificadoLoc[key].display) {
        const newCertificadoLoc = { ...certificadoLoc };
        newCertificadoLoc[key].display = false;

        setCertificadoLoc(newCertificadoLoc);
      }
    },
    [certificadoLoc]
  );

  const handleDrag = useCallback(
    (e, d, key) => {
      const newCertificadoLoc = { ...certificadoLoc };

      if (key === "iconcurso_loc" || key === "qrcode_loc") {
        return;
      }

      if (
        pxToCm(d.x) <
          Number(props.certificado.cert_w) - newCertificadoLoc[key].w &&
        pxToCm(d.x) > 0
      ) {
        newCertificadoLoc[key].x = pxToCm(d.x);
      }

      if (
        pxToCm(d.x) >=
        Number(props.certificado.cert_w) - newCertificadoLoc[key].w
      ) {
        newCertificadoLoc[key].x =
          Number(props.certificado.cert_w) - newCertificadoLoc[key].w;
      }

      if (pxToCm(d.x) <= 0) {
        newCertificadoLoc[key].x = 0;
      }

      if (
        pxToCm(d.y) <
          Number(props.certificado.cert_h) - newCertificadoLoc[key].h &&
        pxToCm(d.y) > 0
      ) {
        newCertificadoLoc[key].y = pxToCm(d.y);
      }

      if (
        pxToCm(d.y) >=
        Number(props.certificado.cert_h) - newCertificadoLoc[key].h
      ) {
        newCertificadoLoc[key].y =
          Number(props.certificado.cert_h) - newCertificadoLoc[key].h;
      }

      if (pxToCm(d.y) <= 0) {
        newCertificadoLoc[key].y = 0;
      }

      setCertificadoLoc(newCertificadoLoc);
    },
    [certificadoLoc]
  );

  const handleResize = useCallback(
    (e, direction, ref, delta, position, key) => {
      const newCertificadoLoc = { ...certificadoLoc };

      newCertificadoLoc[key].w = pxToCm(ref.offsetWidth);
      newCertificadoLoc[key].h = pxToCm(ref.offsetHeight);

      setCertificadoLoc(newCertificadoLoc);
    },
    [certificadoLoc]
  );

  const handleFile = useCallback((e) => {
    const { files } = e.target;
    const objectUrl = URL.createObjectURL(files[0]);

    setBackgroundImageUrl(objectUrl);
    setBackgroundImage(files[0]);
  }, []);

  const handleFontSize = useCallback(
    (key) => {
      const maxWidth =
        cmToPx(certificadoLoc[key].w) / certificadoLoc[key].text.length;
      const maxHeight = cmToPx(certificadoLoc[key].h) - 10;

      if (key === "iconcurso_loc" || key === "qrcode_loc") {
        return maxHeight - 10;
      }

      return maxWidth;
    },
    [certificadoLoc]
  );

  return (
    <Container
      width={props.certificado.cert_w}
      height={props.certificado.cert_h}
      image={backgroundImageUrl}
    >
      {Object.keys(certificadoLoc)
        .filter((key) => certificadoLoc[key].display && key !== "fundo_loc")
        .map((key) => (
          <Rnd
            size={{
              width: cmToPx(certificadoLoc[key].w),
              height: cmToPx(certificadoLoc[key].h),
            }}
            position={{
              x: cmToPx(certificadoLoc[key].x),
              y: cmToPx(certificadoLoc[key].y),
            }}
            onDragStop={(e, d) => handleDrag(e, d, key)}
            onResize={(e, direction, ref, delta, position) =>
              handleResize(e, direction, ref, delta, position, key)
            }
            isDraggable={false}
          >
            <RndContent
              onClick={(e) => deleteField(e, key)}
              fontSize={() => handleFontSize(key)}
            >
              {certificadoLoc[key].icon}{" "}
              {key === "iconcurso_loc" ||
                key === "qrcode_loc" ||
                certificadoLoc[key].text}
            </RndContent>
          </Rnd>
        ))}

      <CertificateMenu>
        {Object.keys(certificadoLoc)
          .filter((key) => key !== "fundo_loc")
          .map((key) => (
            <li onClick={() => showField(key)}>
              {certificadoLoc[key].icon} {certificadoLoc[key].text}
            </li>
          ))}
        <label>
          <i class="image icon"></i> Imagem de Fundo
          <input
            type="file"
            accept="image/jpeg,image/x-png"
            style={{
              display: "none",
            }}
            onChange={handleFile}
          />
        </label>
      </CertificateMenu>
    </Container>
  );
};

export default CertificateEditor;
